// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyApzbanRgYuv3n-ohAemddr5Qppr5yQ020",
    authDomain: "hotel-aef2b.firebaseapp.com",
    projectId: "hotel-aef2b",
    storageBucket: "hotel-aef2b.appspot.com",
    messagingSenderId: "871753425702",
    appId: "1:871753425702:web:98d3a9fb0682bacd2957e7",
    measurementId: "G-Q7GDFE47S6"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

export default firebaseApp